import { ContentFragmentType } from './Content';
import { createGuid } from '../../api/public/utils/Guid';
export const ColumnHelper = {
    build: (id, widget) => ({
        _id: id,
        type: ContentFragmentType.Column,
        value: { widget },
    }),
    createEmptyColumn: () => ColumnHelper.build(createGuid(), undefined),
    createEmptyColumns: (count) => range(count).map(ColumnHelper.createEmptyColumn),
    isColumn: (fragment) => fragment.type === ContentFragmentType.Column,
};
const range = (size) => new Array(size).fill(undefined).map((_, i) => i);
